import { CheckIcon } from '@heroicons/react/24/outline'
import { IconConfetti } from '@tabler/icons-react'

export const PricingCadenceSelector = ({
  billingCycle,
  setBillingCycle,
}: {
  billingCycle: string
  setBillingCycle: React.Dispatch<React.SetStateAction<'Monthly' | 'Annual'>>
}) => {
  return (
    <div className="mb-2 mt-4 flex w-full items-center justify-center gap-1 overflow-visible pt-1 text-center text-xs font-medium">
      <button
        className={`rounded-l-md px-2 py-1 ${
          billingCycle === 'Monthly'
            ? 'bg-slate-600 text-white'
            : 'bg-slate-100'
        }`}
        onClick={() => setBillingCycle('Monthly')}
      >
        Monthly pricing
      </button>
      <button
        className={`relative flex overflow-visible rounded-r-md px-2 py-1 ${
          billingCycle === 'Annual' ? 'bg-slate-800 text-white' : 'bg-slate-100'
        }`}
        onClick={() => setBillingCycle('Annual')}
      >
        <span>Annual pricing</span>
        <div className="absolute -top-6 left-0 right-0 z-50 -ml-2 flex w-[180px] items-center justify-center gap-1 rounded-md py-1 text-[10px] text-slate-800 md:top-0 md:left-full md:w-[180px] md:text-xs">
          <IconConfetti className="h-4 w-4 text-toasty-blue-500" />
          Annual saves up to 53%
        </div>
      </button>
    </div>
  )
}
